/**
 * Plain store for wellness practice progress. No React Context.
 * Screens and WellnessProgressTracker import this and call getState/setLine/etc.
 */

const TICK_MS = 50;

const INITIAL = { line1: 0, line2: 0, line3: 0, line4: 0 };

let state = { ...INITIAL };
let listeners = new Set();
let intervalId = null;
let animation = { lineKey: null, start: 0, durationMs: 0 };

function getState() {
  return { ...state };
}

function setState(updater) {
  state =
    typeof updater === "function" ? updater(state) : { ...state, ...updater };
  listeners.forEach((cb) => cb());
}

function setLine(lineKey, value) {
  setState((prev) => ({ ...prev, [lineKey]: value }));
}

function setLineProgressAnimated(lineKey, durationMs) {
  if (intervalId != null) {
    clearInterval(intervalId);
    intervalId = null;
  }
  const start = Date.now();
  animation = { lineKey, start, durationMs };

  const tick = () => {
    if (!animation.lineKey || animation.durationMs <= 0) return;
    const elapsed = Date.now() - animation.start;
    const progress = Math.min(100, (elapsed / animation.durationMs) * 100);
    setLine(animation.lineKey, progress);
    if (progress >= 100) {
      if (intervalId != null) clearInterval(intervalId);
      intervalId = null;
      animation = { lineKey: null, start: 0, durationMs: 0 };
    }
  };

  tick();
  intervalId = setInterval(tick, TICK_MS);
}

function resetProgress() {
  if (intervalId != null) {
    clearInterval(intervalId);
    intervalId = null;
  }
  animation = { lineKey: null, start: 0, durationMs: 0 };
  state = { ...INITIAL };
  listeners.forEach((cb) => cb());
}

function subscribe(callback) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}

export default {
  getState,
  setState,
  setLine,
  setLineProgressAnimated,
  resetProgress,
  subscribe,
};
